import * as React from "react";
import { useState } from "react";
import { Sidebar, Menu, MenuItem, useProSidebar } from "react-pro-sidebar";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AttractionsIcon from "@mui/icons-material/Attractions";
import AddTaskIcon from "@mui/icons-material/AddTask";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import OnDeviceTrainingIcon from '@mui/icons-material/OnDeviceTraining';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssessmentIcon from '@mui/icons-material/Assessment';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import DescriptionIcon from '@mui/icons-material/Description';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import CurrencyRubleIcon from '@mui/icons-material/CurrencyRuble';
import FactCheckRoundedIcon from "@mui/icons-material/FactCheckRounded";
import GroupsIcon from '@mui/icons-material/Groups';


import {
  Box,
  Avatar,
  IconButton,
  Typography,
  useTheme,
  Tooltip,
  ListItem,
  Divider,
} from "@mui/material";
import { tokens } from "../../Theme";
import { useNavigate } from "react-router-dom";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import SourceOutlinedIcon from "@mui/icons-material/SourceOutlined";
// import ESS from "../../assets/img/esslogo6.png";
import ESS from "../../assets/img/BexATM.png";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import CoPresentIcon from '@mui/icons-material/CoPresent';
import Collapse from "@mui/material/Collapse";
import ExpandMore from "@mui/icons-material/ExpandMore";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import ChevronRightOutlinedIcon from "@mui/icons-material/ChevronRightOutlined";
import HowToRegOutlinedIcon from "@mui/icons-material/HowToRegOutlined";
import TaskOutlinedIcon from '@mui/icons-material/TaskOutlined';
import RequestQuoteOutlinedIcon from "@mui/icons-material/RequestQuoteOutlined";
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import AttributionIcon from "@mui/icons-material/Attribution";
import { menuHeight } from "./utils";
import AvTimerOutlinedIcon from "@mui/icons-material/AvTimerOutlined";
import WorkHistoryOutlinedIcon from "@mui/icons-material/WorkHistoryOutlined";
import AppRegistrationOutlinedIcon from "@mui/icons-material/AppRegistrationOutlined";
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
import PendingActionsOutlinedIcon from "@mui/icons-material/PendingActionsOutlined";
import PersonPinOutlinedIcon from "@mui/icons-material/PersonPinOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import MoreTimeOutlinedIcon from "@mui/icons-material/MoreTimeOutlined";
import FollowTheSignsOutlinedIcon from "@mui/icons-material/FollowTheSignsOutlined";
import WorkOutlinedIcon from "@mui/icons-material/WorkOutlined";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
import EuroSymbolIcon from '@mui/icons-material/EuroSymbol';
import ExplicitIcon from '@mui/icons-material/Explicit';
import ChecklistIcon from '@mui/icons-material/Checklist';
import ChecklistRtlIcon from '@mui/icons-material/ChecklistRtl';
import TodayIcon from '@mui/icons-material/Today';
import TransferWithinAStationIcon from '@mui/icons-material/TransferWithinAStation';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import DatasetLinkedIcon from '@mui/icons-material/DatasetLinked';
import { FeedOutlined, Psychology } from "@mui/icons-material";
import FactCheckIcon from '@mui/icons-material/FactCheck';
import BallotIcon from '@mui/icons-material/Ballot';
import store from "../..";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { logout } from "../../store/reducers/LoginReducer";
import ReceiptIcon from '@mui/icons-material/Receipt';

const Item = ({ title, to, icon, selected, setSelected, isChild }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const colors = tokens(theme.palette.mode);

  function cal() {
    setSelected(title);
    navigate(to);
  }

  return (
    <MenuItem
      style={{ marginLeft: isChild ? "-11px" : "" }}
      active={selected === title}
      icon={icon}
      onClick={cal}
    >
      <Typography>{title}</Typography>
    </MenuItem>
  );
};

const Sidebars = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selected, setSelected] = useState("Product Category");
  const EmpId = sessionStorage.getItem("EmpId");
  const companyID = sessionStorage.getItem("companyId");
  const CompanyLogo = sessionStorage.getItem("CompanyLogo");

  const SubscriptionCode = sessionStorage.getItem("SubscriptionCode");
  const is003Subscription = SubscriptionCode.endsWith("003");
  const Classification = sessionStorage.getItem("Classification");
  console.log(SubscriptionCode, is003Subscription, Classification, "SubscriptionCode");
  const baseUrl1 = useSelector((state) => state.globalurl.baseUrl1);

  const Logo =
    CompanyLogo && baseUrl1
      ? `${baseUrl1}uploads/images/${CompanyLogo}`
      : ESS;
  // const Logo = CompanyLogo
  //   ? `${store.getState().globalurl.baseUr1l}uploads/images/${CompanyLogo}`
  //   : ESS
  // "https://bosuat.beyondexs.com/uploads/images/20251222_124012_logo_V1_1.png"

  console.log("CompanyLogo:", CompanyLogo);
  console.log("Logo URL:", Logo);

  // --------------------------
  // menuType controls "All / task / project / attendance"
  // --------------------------
  // const menuType = sessionStorage.getItem("Module") || "All";
  // example usage:
  // sessionStorage.setItem("menuType", "task");

  // --------------------------
  // Menu data (mix: some parents have visibleFor, many children have visibleFor)
  // You can tweak visibleFor arrays easily.
  // --------------------------
  const menuType = (sessionStorage.getItem("All") || "All").split(",");
  console.log(menuType, "MenuType")
  const isItemVisible = (item) => {
    // If parent defines visibleFor -> use it
    if (item.visibleFor && Array.isArray(item.visibleFor)) {
      // Check if any menuType matches visibleFor
      return menuType.some((mt) => item.visibleFor.includes(mt));
    }

    // If item has children -> show if any child is visible
    if (item.children && Array.isArray(item.children)) {
      return item.children.some(
        (ch) =>
          // child visible if no visibleFor (defaults to visible) OR visibleFor includes any menuType
          !ch.visibleFor || menuType.some((mt) => ch.visibleFor.includes(mt))
      );
    }

    // Leaf without visibleFor defaults to visible
    return true;
  };

  const child = {
    data: [
      {
        name: "Check In",
        id: 45,
        url: "/Apps/TR123/Check In/EditCheck In/-1/A",
        icon: (
          <Tooltip title="Check In">
            <ChecklistIcon color="info" />
          </Tooltip>
        ),
        UGA_ACCESSIDS: "TR123",
        visibleFor: ["All", "Attendance"],
      },
      {
        name: "Check Out",
        id: 46,
        url: "/Apps/TR124/Check%20Out",
        icon: (
          <Tooltip title="Check Out">
            <ChecklistRtlIcon color="info" />
          </Tooltip>
        ),
        UGA_ACCESSIDS: "TR124",
        visibleFor: ["All", "Attendance"],
      },

      {
        name: is003Subscription ? "Daily Activities" : "Scrum Task",
        id: 149,
        url: is003Subscription
          ? `/Apps/TR354/Scrum Task`
          : `/Apps/TR132/Scrum Task`,
        // url: "/Apps/TR132/Scrum Task",
        icon: (
          <Tooltip title={is003Subscription ? "Daily Activities" : "Scrum Task"}>
            <TodayIcon color="info" />
          </Tooltip>
        ),
        UGA_ACCESSIDS: "TR132",
        visibleFor: ["All", "Task"],
      },

      {
        name: "Self Services",
        id: 455869,
        Tooltipname: "Self Services",
        MenuID: "SE103430",
        icon: (
          <Tooltip title="Self Services">
            <ConnectWithoutContactIcon sx={{ color: "#651fff" }} />
          </Tooltip>
        ),
        visibleFor: ["All", "attendance", "Request"],

        // parent has no visibleFor -> children control visibility
        children: [
          {
            name: "Permission",
            id: 129,
            url: "/Apps/TR266/Permission",
            icon: (
              <Tooltip title="Permission">
                <CoPresentIcon color="info" />
              </Tooltip>
            ),
            UGA_ACCESSIDS: "TR266",
            visibleFor: ["All", "Request"],
          },
          {
            name: "Leave",
            id: 47,
            url: "/Apps/TR208/Leave",
            icon: (
              <Tooltip title="Leave">
                <FollowTheSignsOutlinedIcon color="info" />
              </Tooltip>
            ),
            UGA_ACCESSIDS: "TR208",
            visibleFor: ["All", "Attendance", "Request"],
          },
          ...(Classification !== "Student" ? [
            {
              name: "On Duty",
              url: "/Apps/TR242/On%20Duty",
              id: 79,
              icon: (
                <Tooltip title="On Duty">
                  <WorkOutlinedIcon color="info" />
                </Tooltip>
              ),
              UGA_ACCESSIDS: "TR242",
              visibleFor: ["All", "Attendance", "Request"],
            },

            {
              name: "Overtime",
              url: "/Apps/TR216/Over Time",
              id: 77,
              icon: (
                <Tooltip title="Overtime">
                  <MoreTimeOutlinedIcon color="info" />
                </Tooltip>
              ),
              UGA_ACCESSIDS: "TR216",
              visibleFor: ["All", "Attendance", "Request"],
            },

            {
              name: "Regularization",
              id: 128,
              url: "/Apps/TR219/Regularization",
              icon: (
                <Tooltip title="Regularization">
                  <AttributionIcon color="info" />
                </Tooltip>
              ),
              UGA_ACCESSIDS: "TR219",
              visibleFor: ["All", "Attendance", "Request"],
            },
          ]
            : []),

          {
            name: "Expense",
            id: 41,
            url: "/Apps/Secondarylistview/TR086/Finance%20Entry/E",
            icon: (
              <Tooltip title="Expense">
                <ExplicitIcon color="info" />
              </Tooltip>
            ),
            UGA_ACCESSIDS: "TR086",
            visibleFor: ["All", "Request"],
          },
 ...(Classification !== "Student" ? [
 {
            name: "Salary Advance",
            id: 128,
            url: "/Apps/TR160/Salary%20Advance",
            icon: (
              <Tooltip title="Salary Advance">
                <RequestQuoteOutlinedIcon color="info" />
              </Tooltip>
            ),
            UGA_ACCESSIDS: "TR160",
            visibleFor: ["All", "Request"],
          },
 ]
            : []),
         

        ],
      },

      {
        name: "Manager Desk",
        id: 18,
        Tooltipname: "Manager Desk",
        MenuID: "SE101",
        icon: (
          <Tooltip title="Manager Desk">
            <FactCheckIcon sx={{ color: "#651fff" }} />
          </Tooltip>
        ),
        // parent-level visibleFor: show Manager Desk only for All/task (for example)
        visibleFor: ["All", "Request", "Task", "Attendance"],
        children: [
          {
            name: "Approvals",
            url: `/Apps/Secondarylistview/TR245/Employees/${EmpId}`,
            id: 81,
            icon: (
              <Tooltip title="Approval">
                <PersonPinOutlinedIcon color="info" />
              </Tooltip>
            ),
            UGA_ACCESSIDS: "TR245",
            visibleFor: ["All", "Request"],
          },
          {
            name: is003Subscription ? "Task Allocation" : "Tasks",
            url: is003Subscription
              ? `/Apps/Secondarylistview/TR353/Tasks/${EmpId}`
              : `/Apps/Secondarylistview/TR263/Tasks/${EmpId}`,
            // url: `/Apps/Secondarylistview/TR263/Tasks/${EmpId}`,
            id: 121,
            icon: (
              <Tooltip title={is003Subscription ? "Task Allocation" : "Tasks"}>
                <AddTaskIcon color="info" />
              </Tooltip>
            ),
            UGA_ACCESSIDS: "TR263",
            visibleFor: ["All", "Task"],
          },
          //          ...(is003Subscription
          // ? [
          //      {
          //         name: "Timetable",
          //         url: "/Apps/TR368/Timetable",
          //         id: 832,
          //         icon: (
          //           <Tooltip title="Timetable">
          //             <DatasetLinkedIcon color="info" />
          //           </Tooltip>
          //         ),
          //         UGA_ACCESSIDS: "TR365",
          //         visibleFor: ["All", "Timetable"],
          //       },
          //            ]
          // : []),
          ...(is003Subscription
            ? [
              {
                name: "Homework",
                url: "/Apps/TR365/Homework",
                id: 832,
                icon: (
                  <Tooltip title="Homework">
                    <HomeWorkIcon color="info" />
                  </Tooltip>
                ),
                UGA_ACCESSIDS: "TR365",
                visibleFor: ["All", "Homework"],
              },

            ]
            : []),
          ...(!is003Subscription
            ? [
              {
                name: "Onsite Activities",
                id: 49,
                // url: "/Apps/TR264/Onsite%20Activities",
                url: "/Apps/TR293/Onsite%20Activities",
                icon: (
                  <Tooltip title="Onsite Activities">
                    <AttractionsIcon color="info" />
                  </Tooltip>
                ),
                // UGA_ACCESSIDS: "TR264",
                UGA_ACCESSIDS: "TR293",
                visibleFor: ["All", "Attendance"],
              },
            ]
            : []),
          {
            name: "Attendance Entry",
            url: "/Apps/EditAttendanceEntry",
            id: 831,
            icon: (
              <Tooltip title="Attendance Entry">
                <HowToRegIcon color="info" />
              </Tooltip>
            ),
            UGA_ACCESSIDS: "TR351",
            visibleFor: ["All", "Attendance"],
          },
          {
            name: "Attendance Register",
            url: "/Apps/TR250/EditAttendanceHistory",
            id: 83,
            icon: (
              <Tooltip title="Attendance Register">
                <WorkHistoryOutlinedIcon color="info" />
              </Tooltip>
            ),
            UGA_ACCESSIDS: "TR250",
            visibleFor: ["All", "Attendance"],
          },
          // {
          //   name: "SOP",
          //   url: "/Apps/TR250/EditAttendanceHistory",
          //   id: 563,
          //   icon: (
          //     <Tooltip title="SOP">
          //       <AdminPanelSettingsOutlinedIcon color="info" />
          //     </Tooltip>
          //   ),
          //   // UGA_ACCESSIDS: "TR250",
          //   visibleFor: ["All", "Attendance"],
          // },
          // {
          //   name: "Invoice",
          //   // url: "/Apps/TR250/Invoice",
          //   // url: "/Apps/TR331/Invoice",
          //   url: is003Subscription ? "/Apps/TR331/Invoice" : "/Apps/TR366/Invoice",
          //   id: 88,
          //   icon: (
          //     <Tooltip title="Invoice">
          //       <ReceiptIcon color="info" />
          //     </Tooltip>
          //   ),
          //   UGA_ACCESSIDS: is003Subscription ? "TR331" : "TR366",
          //   visibleFor: ["All", "Attendance"],
          // },
        ],
      },

     {
        name: is003Subscription ? "Academic Details" : "Agile",
        id: 8,
        Tooltipname: is003Subscription ? "Academics" : "Agile",
        MenuID: "SE100",
        icon: (
          <Tooltip title={is003Subscription ? "Academics" : "Agile"}>
            <AvTimerOutlinedIcon sx={{ color: "#651fff" }} />
          </Tooltip>
        ),
        visibleFor: ["All", "Project", "Attendance", "Task"],
        // parent has no visibleFor here — children decide
        children: [
          {
            name: is003Subscription ? "Classes" : "Project",
            id: 4346894,
            url: `./TR133/${is003Subscription ? "Classes" : "Project"}`,
            icon: (
              <Tooltip title={is003Subscription ? "Classes" : "Project"}>
                <SourceOutlinedIcon color="info" />
              </Tooltip>
            ),
            UGA_ACCESSIDS: "TR133",
            visibleFor: ["All", "Project", "Attendance"],
          },
          {
            name: "Routine Tasks",
            id: 4346896,
            url: "./TR276/Project",
            icon: (
              <Tooltip title="Routine Tasks">
                <TransferWithinAStationIcon color="info" />
              </Tooltip>
            ),
            UGA_ACCESSIDS: "TR269",
            visibleFor: ["All", "Project"],
          },
          {
            name: "Sprint",
            id: 4346895,
            url: "./TR269/Sprint",
            icon: (
              <Tooltip title="Sprint">
                <TaskAltIcon color="info" />
              </Tooltip>
            ),
            UGA_ACCESSIDS: "TR269",
            visibleFor: ["All", "Task", "Project"],
          },
          {
            name: "Project Enquiry",
            id: 43468965,
            url: "./ProjectEnquiry",
            icon: (
              <Tooltip title="Project Enquiry">
                <OnDeviceTrainingIcon color="info" />
              </Tooltip>
            ),
            UGA_ACCESSIDS: "TR2691",
            visibleFor: ["All", "Attendance", "Project"],
          },
          {
            name: "Project Report",
            url: "/Apps/TR253/ProjectStatusReport",
            id: 85,
            icon: (
              <Tooltip title="Project Report">
                <AssessmentIcon color="info" />
              </Tooltip>
            ),
            UGA_ACCESSIDS: "TR253",
            visibleFor: ["All", "Project"],
          },
          ...(Classification !== "Student"? [
            {
              name: "Attendance(D)",
              url: "/Apps/TR217/Editdailyattendance",
              id: 81,
              icon: (
                <Tooltip title="Daily Attendance">
                  <AppRegistrationOutlinedIcon color="info" />
                </Tooltip>
              ),
              UGA_ACCESSIDS: "TR217",
              visibleFor: ["All", "Attendance"],
            }
          ]
            : []),
          {
            name: "Attendance(M)",
            url: "/Apps/TR217/EditAttendance",
            id: 82,
            icon: (
              <Tooltip title="Monthly Attendance">
                <BallotIcon color="info" />
              </Tooltip>
            ),
            UGA_ACCESSIDS: "TR217",
            visibleFor: ["All", "Attendance"],
          },
            ...(is003Subscription
            ? [{
            name: "Holiday List",
            url: "/Apps/TR218/Holiday List",
            id: 89,
            icon: (
              <Tooltip title="Holiday List">
                <FactCheckRoundedIcon color="info" />
              </Tooltip>
            ),
            UGA_ACCESSIDS: "TR218",
            visibleFor: ["All", "Attendance"],
          },
        ]:  []),
            ...(is003Subscription && Classification === "Student"
            ? [{
                name: "Feedback",
                url: "/Apps/TR391/Feedback",
                id: 121,
                icon: (
                  <Tooltip title="Feedback">
                    <FeedOutlined color="info" />
                  </Tooltip>
                ),
                UGA_ACCESSIDS: "TR391",
                visibleFor: ["All", "Task"],
              },
        ]:  []),
         
              // {
              //   name: "Feedback",
              //   url: "/Apps/TR391/Feedback",
              //   id: 121,
              //   icon: (
              //     <Tooltip title="Feedback">
              //       <FeedOutlined color="info" />
              //     </Tooltip>
              //   ),
              //   UGA_ACCESSIDS: "TR391",
              //   visibleFor: ["All", "Task"],
              // },
          {
            name: "Movements",
            url: "/Apps/TR217/Editmovements",
            id: 821,
            icon: (
              <Tooltip title="Movements">
                <DirectionsWalkIcon color="info" />
              </Tooltip>
            ),
            UGA_ACCESSIDS: "TR217",
            visibleFor: ["All", "Attendance"],
          },
 
          {
            name: "Timesheet",
            url: "/Apps/TR251/EditTimeSheet",
            id: 84,
            icon: (
              <Tooltip title="Timesheet">
                <PendingActionsOutlinedIcon color="info" />
              </Tooltip>
            ),
            UGA_ACCESSIDS: "TR251",
            visibleFor: ["All", "Task"],
          },
          ...(is003Subscription ? [
 {
            name: "Invoice",
            url: Classification === "Student" ? "/Apps/TR392/Invoice" : "/Apps/TR394/Invoice",
            id: 94,
            icon: (
              <Tooltip title="Invoice">
                <ReceiptIcon color="info" />
              </Tooltip>
            ),
            UGA_ACCESSIDS: Classification === "Student" ? "TR392" : "TR394",
            visibleFor: ["All", "Invoice"],
          },
             ]
  : []),
          
  //         ...(Classification !== "Student" && is003Subscription
  // ? [
  //           {
  //     name: "Invoice",
  //     id: 56,
  //     url: "./TeacherInvoice",
  //     icon: (
  //       <Tooltip title="Invoice">
  //         <GroupsIcon color="info" />
  //       </Tooltip>
  //     ),
     
  //     visibleFor: ["All", "Invoice"],
  //   },
  //     ]
  // : []),
 
          ...(Classification === "Student" && is003Subscription
            ? [
              {
                name: "Teachers",
                id: 56,
                url: "./Teachers",
                icon: (
                  <Tooltip title="Teachers">
                    <GroupsIcon color="info" />
                  </Tooltip>
                ),
 
                visibleFor: ["All", "Teachers"],
              },
            ]
            : []),
 
        ],
      },
    
      {
        name: "Assessment",
        id: 99,
        //url: "/Apps/TR290/List Of Assessment",
        url: "/Apps/TR308/List Of Assessment Type",
        icon: (
          <Tooltip title="Assessment">
            <Psychology color="info" />
          </Tooltip>
        ),
        UGA_ADD: true,
        UGA_DEL: true,
        UGA_MOD: true,
        UGA_PRINT: true,
        UGA_PROCESS: true,
        UGA_VIEW: true,
        UGA_ACCESSIDS: "TR287",
        visibleFor: ["All", "Assessment"],
      },

      // {
      //   name: "Appraisal",
      //   id: 987,
      //   url: "/Apps/skillglow/Appraisallistpage",
      //   icon: (
      //     <Tooltip title="Appraisal">
      //       <FactCheckOutlinedIcon color="info" />
      //     </Tooltip>
      //   ),
      //   UGA_ADD: true,
      //   UGA_DEL: true,
      //   UGA_MOD: true,
      //   UGA_PRINT: true,
      //   UGA_PROCESS: true,
      //   UGA_VIEW: true,
      //   UGA_ACCESSIDS: "TR287",
      // visibleFor: ["All","Assessment"],
      // },
      {
        name: "My Profile",
        url: "./TR027/my-profile",
        id: 42,
        icon: (
          <Tooltip title="My Profile">
            <AccountCircleOutlinedIcon color="info" />
          </Tooltip>
        ),
        UGA_ACCESSIDS: "TR027",
        visibleFor: ["All", "Myprofile"],
      },
      ...(Classification !== "Student" && Classification !== "Board Of Directors" && is003Subscription
        ? [
          {
            name: "Payslip",
            url: "./TR381/Payslip",
            id: 412,
            icon: (
              <Tooltip title="Payslip">
                <CurrencyRubleIcon color="info" />
              </Tooltip>
            ),
            UGA_ACCESSIDS: "TR381",
            visibleFor: ["All", "Payslip"],
          },
        ]
        : []),


    ],
  };
  // {
  //   companyID == "204" && (
  //     [
  //       {
  //         name: "Scrum Task",
  //         id: 149,
  //         url: "/Apps/TR132/Scrum Task",
  //         icon: (
  //           <Tooltip title="Scrum Task">
  //             <TodayIcon color="info" />
  //           </Tooltip>
  //         ),
  //         UGA_ACCESSIDS: "TR132",
  //         visibleFor: ["All", "Task"],
  //       },
  //       {
  //         name: "Tasks",
  //         url: `/Apps/Secondarylistview/TR263/Tasks/${EmpId}`,
  //         id: 121,
  //         icon: (
  //           <Tooltip title="Tasks">
  //             <AddTaskIcon color="info" />
  //           </Tooltip>
  //         ),
  //         UGA_ACCESSIDS: "TR263",
  //         visibleFor: ["All", "Task"],
  //       },
  //       {
  //         name: "Time Sheet",
  //         url: "/Apps/TR251/EditTimeSheet",
  //         id: 84,
  //         icon: (
  //           <Tooltip title="Time Sheet">
  //             <PendingActionsOutlinedIcon color="info" />
  //           </Tooltip>
  //         ),
  //         UGA_ACCESSIDS: "TR251",
  //         visibleFor: ["All", "Task"],
  //       },
  //       {
  //         name: "My Profile",
  //         url: "./TR027/my-profile",
  //         id: 42,
  //         icon: (
  //           <Tooltip title="My Profile">
  //             <AccountCircleOutlinedIcon color="info" />
  //           </Tooltip>
  //         ),
  //         UGA_ACCESSIDS: "TR027",
  //         visibleFor: ["All", "Myprofile"],
  //       },
  //     ]
  //   )
  // }
  const EmpName = sessionStorage.getItem("EmpName");
  const isManager = sessionStorage.getItem("isManager");
  const isScrumaster = sessionStorage.getItem("isScrumaster");
  const isprojectmanager = sessionStorage.getItem("isprojectmanager");
  const qualityassurance = sessionStorage.getItem("qualityassurance");
  const handleLogout = () => {
    sessionStorage.clear(); // clear session only
    navigate("/");
  };
  const handleClicks = (item) => {
    let newData = { ...menu, [item]: !menu[item] };
    setMenu(newData);
  };
  const [menu, setMenu] = useState({});
  // FINAL MENU SELECTION
  const company208Menu = [
    {
      name: "Scrum Task",
      id: 149,
      url: is003Subscription
        ? `/Apps/TR354/Scrum Task`
        : `/Apps/TR132/Scrum Task`,
      // url: "/Apps/TR132/Scrum Task",
      icon: (
        <Tooltip title="Scrum Task">
          <TodayIcon color="info" />
        </Tooltip>
      ),
      visibleFor: ["All", "Task"],
    },
    {
      name: "Manager Tasks",
      id: 121,
      url: `/Apps/Secondarylistview/TR263/Tasks/${EmpId}`,
      icon: (
        <Tooltip title="Tasks">
          <AddTaskIcon color="info" />
        </Tooltip>
      ),
      visibleFor: ["All", "Task"],
    },
    {
      name: "Time Sheet",
      id: 84,
      url: "/Apps/TR251/EditTimeSheet",
      icon: (
        <Tooltip title="Time Sheet">
          <PendingActionsOutlinedIcon color="info" />
        </Tooltip>
      ),
      visibleFor: ["All", "Task"],
    },


    {
      name: "My Profile",
      id: 42,
      url: "./TR027/my-profile",
      icon: (
        <Tooltip title="My Profile">
          <AccountCircleOutlinedIcon color="info" />
        </Tooltip>
      ),
      visibleFor: ["All", "Myprofile"],
    },
    // {
    //   name: "Attendance Entry",
    //   url: "/Apps/EditAttendanceEntry",
    //   id: 831,
    //   icon: (
    //     <Tooltip title="Attendance Entry">
    //       <HowToRegIcon color="info" />
    //     </Tooltip>
    //   ),
    //   UGA_ACCESSIDS: "TR351",
    //   visibleFor: ["All", "Task"],
    // },
    // {
    //   name: "Attendance(M)",
    //   url: "/Apps/TR217/EditAttendance",
    //   id: 82,
    //   icon: (
    //     <Tooltip title="Monthly Attendance">
    //       <BallotIcon color="info" />
    //     </Tooltip>
    //   ),
    //   UGA_ACCESSIDS: "TR217",
    //   visibleFor: ["All", "Ta"],
    // },
  ];
  let finalMenu =
    companyID === "208" ? company208Menu : child.data;
  console.log(finalMenu, companyID, "check Menu");
  // --------------------------
  // helper: check visibility for an item (supports mix of parent/child visibleFor)
  // --------------------------
  // const isItemVisible = (item) => {
  //   // If parent defines visibleFor -> use it
  //   if (item.visibleFor && Array.isArray(item.visibleFor)) {
  //     return item.visibleFor.includes(menuType);
  //   }

  //   // If item has children -> show if any child is visible
  //   if (item.children && Array.isArray(item.children)) {
  //     return item.children.some(
  //       (ch) =>
  //         // child visible if no visibleFor (defaults to visible) OR visibleFor includes menuType
  //         (!ch.visibleFor || ch.visibleFor.includes(menuType))
  //     );
  //   }

  //   // Leaf without visibleFor defaults to visible
  //   return true;
  // };

  const handleMenu = (childrens, isChild) => {
    return childrens
      .filter((item) => {
        // filter by module visibility
        return isItemVisible(item);
      })
      .map(
        ({
          children,
          name,
          url,
          icon,
          Tooltipname,
          id,
          UGA_ACCESSIDS,
          MenuID,
        }) => {
          if (
            is003Subscription &&
            (name === "Project Enquiry" || name === "Project Report")
          ) {
            return null;
          }
          // CASE: No children (leaf menu items)
          if (!children) {
            const hasAccess =
              (isprojectmanager === "Y" && UGA_ACCESSIDS === "TR133") ||
              (isScrumaster === "Y" && UGA_ACCESSIDS === "TR269") ||
              (UGA_ACCESSIDS !== "TR133" && UGA_ACCESSIDS !== "TR269");

            if (hasAccess) {
              return (
                <List component="div" disablePadding key={id}>
                  <ListItem
                    disableGutters
                    style={{ padding: "0px", height: menuHeight }}
                  >
                    <Item
                      isChild={isChild}
                      //title={name}
                      title={!collapsed ? name : ""}     // hide text
                      to={url}
                      icon={icon}
                      selected={selected}
                      setSelected={setSelected}
                    />
                  </ListItem>
                </List>
              );
            }

            return null; // no access, don't render
          }

          // CASE: Parent with children (collapsible)
          if ((isManager === "1" && MenuID === "SE101") || MenuID !== "SE101") {
            return (
              <div key={id}>
                <ListItem
                  disableGutters
                  style={{ padding: "0px", height: menuHeight }}
                  onClick={() => handleClicks(name)}
                >
                  {!collapsed ? (
                    <Tooltip title={Tooltipname}>
                      <ListItemButton>
                        <ListItemIcon>{icon}</ListItemIcon>
                        {!collapsed && (<ListItemText
                          style={{ marginLeft: "-21px" }}
                          primary={name}
                        />)}
                        {menu[name] ? <ExpandMore /> : <ChevronRightOutlinedIcon />}
                      </ListItemButton>
                    </Tooltip>
                  ) : (
                    <ListItemButton>
                      <ListItemIcon>
                        {icon}{" "}
                        {menu[name] ? <ExpandMore /> : <ChevronRightOutlinedIcon />}
                      </ListItemIcon>
                    </ListItemButton>
                  )}
                </ListItem>

                <Collapse in={menu[name]} timeout="auto" unmountOnExit>
                  {handleMenu(children, false)}
                </Collapse>
              </div>
            );
          }

          return null;
        }
      );
  };
  const { collapseSidebar, toggleSidebar, collapsed, broken } = useProSidebar();
  React.useEffect(() => {
    collapseSidebar(true);
  }, [collapseSidebar]);
  return (
    <Box
      sx={{
        position: "sticky",
        display: "flex",
        height: "100vh",
        top: 0,
        bottom: 0,
        zIndex: 7,
        "& .sidebar": {
          border: "none",
        },
        "& .menu-icon": {
          backgroundColor: "transparent !important",
        },
        "& .menu-item": {
          backgroundColor: "transparent !important",
        },
        "& .menu-anchor": {
          color: "inherit !important",
          backgroundColor: "transparent !important",
        },
        "& .menu-item:hover": {
          color: `${colors.blueAccent[500]} !important`,
          backgroundColor: "transparent !important",
        },
        "& .menu-item.active": {
          color: `${colors.greenAccent[500]} !important`,
          backgroundColor: "transparent !important",
        },
      }}
    >
      <Sidebar breakPoint="md" backgroundColor={colors.primary[400]}>
        <Menu>
          <MenuItem
            icon={
              collapsed ? (
                <IconButton onClick={() => collapseSidebar()}>
                  <MenuOutlinedIcon />
                </IconButton>
              ) : undefined
            }
            style={{
              margin: "40px 0 3px 0",
              color: colors.grey[100],
            }}
          >
            {!collapsed && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              // ml="15px"
              >
                <img
                  src={Logo}
                  // style={{ height: "60px", width: "180px" }}
                  style={{ height: "60px", width: "180px", objectFit: "contain" }}
                  onClick={() => {
                    if (isManager == 1 && isScrumaster != "Y" && isprojectmanager != "Y") {
                      navigate("/Apps/manager-dashbord/M");
                      return;
                    }
                    if (qualityassurance == "Y" && isManager == 1) {
                      // navigate("/Apps/scrum-dashbord/P");
                      navigate("/Apps/scrum-dashbord/PM");
                      return;
                    }
                    if (isprojectmanager == "Y" && isManager == 1) {
                      // navigate("/Apps/scrum-dashbord/P");
                      navigate("/Apps/scrum-dashbord/PM");
                      return;
                    }
                    if (isScrumaster == "Y" && isManager == 1) {
                      navigate("/Apps/sprint-dashbord/S");
                      return;
                    }
                    navigate("/Apps/dashbord/E");
                  }}
                />
                {/* <Typography>ESS</Typography> */}
                <IconButton
                  onClick={
                    broken ? () => toggleSidebar() : () => collapseSidebar()
                  }
                >
                  <ArrowBackIcon />
                </IconButton>
              </Box>
            )}
          </MenuItem>

          {!collapsed && (
            <Box
              display="flex"
              flexDirection={"column"}
              justifyContent="space-around"
              width="91%"
              height="67px"
              mt="16px"
              p="7px"
              ml="8px"
              borderRadius="4px"
              boxShadow="rgba(0, 0, 0, 0.25) 0px 25px 50px -12px;"
            >
              <Box display="flex" flexDirection="row" justifyContent={"center"}>
                <Typography variant="h4">Welcome {EmpName}</Typography>
              </Box>
            </Box>
          )}

          <Box mt={1} paddingBottom={3}>
            {handleMenu(finalMenu, true)}

            <Tooltip title="Logout">
              <ListItemButton
                // onClick={() => {
                //   navigate("/");
                //   dispatch(logout());
                // }}
                onClick={() => { handleLogout() }}
              >
                <ListItemIcon>
                  <LogoutOutlinedIcon color="error" />
                </ListItemIcon>

                {!collapsed && <ListItemText primary="Logout" />}
              </ListItemButton>
            </Tooltip>
            <Divider sx={{ mt: 1 }} variant="middle" />
          </Box>
        </Menu>
      </Sidebar>
    </Box>
  );
};

export default Sidebars;
